import { Result } from './result.mjs';

var Option;
(function (Option) {
    Option.isSome = (value) => {
        return value !== undefined && value !== null;
    };
    Option.isNone = (value) => {
        return value === undefined || value === null;
    };
    Option.allSome = (arr) => {
        return arr.every((item) => Option.isSome(item));
    };
    Option.allNone = (arr) => {
        return arr.every((item) => Option.isNone(item));
    };
    Option.filterNone = (arr) => {
        return arr.filter(Option.isSome);
    };
    Option.propertyIsSome = (value, key) => {
        return Option.isSome(value[key]);
    };
    Option.propertyIsNone = (value, key) => {
        return Option.isNone(value[key]);
    };
    Option.getProperty = (value, key) => {
        return Option.map(value, (v) => v[key]);
    };
    Option.getPropertyOrUndefined = (value, key) => {
        return Option.toUndefined(Option.map(value, (v) => v[key]));
    };
    Option.of = (value) => {
        return value;
    };
    Option.first = (value) => {
        for (const v of value) {
            if (Option.isSome(v))
                return v;
        }
        return undefined;
    };
    Option.map = (value, mapper) => {
        if (Option.isSome(value))
            return mapper(value);
        return value;
    };
    Option.mapAsync = (value, mapper) => {
        if (Option.isSome(value))
            return mapper(value);
        return Promise.resolve(value);
    };
    Option.flatMap = (value, mapper) => {
        if (Option.isSome(value))
            return mapper(value);
        return value;
    };
    Option.flatMapAsync = (value, mapper) => {
        if (Option.isSome(value))
            return mapper(value);
        return Promise.resolve(value);
    };
    Option.flatMapFirst = (value, mapper) => {
        for (const v of value) {
            if (Option.isSome(v))
                return mapper(v);
        }
        return undefined;
    };
    Option.flatMapFirstAsync = async (value, mapper) => {
        for (const v of value) {
            if (Option.isSome(v))
                return await mapper(v);
        }
        return undefined;
    };
    Option.toNull = (value) => {
        if (Option.isNone(value))
            return null;
        return value;
    };
    Option.toUndefined = (value) => {
        if (Option.isNone(value))
            return undefined;
        return value;
    };
    function getOrElse(value, defaultValue) {
        if (arguments.length >= 2) {
            if (Option.isSome(value))
                return value;
            return defaultValue;
        }
        return (d) => {
            if (Option.isSome(value))
                return value;
            return d;
        };
    }
    Option.getOrElse = getOrElse;
    function mapOrElse(value, mapper, defaultValue) {
        if (arguments.length >= 3) {
            if (Option.isSome(value))
                return mapper(value);
            return defaultValue;
        }
        return (d) => {
            if (Option.isSome(value))
                return mapper(value);
            return d;
        };
    }
    Option.mapOrElse = mapOrElse;
    Option.mapAsyncOrElse = (value, mapper) => {
        return (defaultValue) => {
            if (Option.isSome(value))
                return mapper(value);
            return Promise.resolve(defaultValue);
        };
    };
    function getOrThrow(value, e) {
        if (arguments.length >= 2) {
            if (Option.isSome(value))
                return value;
            throw e;
        }
        return (err) => {
            if (Option.isSome(value))
                return value;
            throw err;
        };
    }
    Option.getOrThrow = getOrThrow;
    function getOrBad(value, e) {
        if (arguments.length >= 2) {
            if (Option.isSome(value))
                return Result.ok(value);
            return Result.err(e);
        }
        return (err) => {
            if (Option.isSome(value))
                return Result.ok(value);
            return Result.err(err);
        };
    }
    Option.getOrBad = getOrBad;
    Option.doWith = (options, cb) => {
        const ctx = {};
        for (const key in options) {
            if (Option.isNone(options[key])) {
                return undefined;
            }
            ctx[key] = options[key];
        }
        return cb(ctx);
    };
})(Option || (Option = {}));

export { Option };
